import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import PhoneAuthContainer from '../../../../../containers/auth/PhoneAuthContainer';
import Button from '../../../../../components/global/Button';
import useRequestConfirm from '../../../../../hooks/useRequestConfirm';
import WarningIcon from '../../../../../components/icons/WarningIcon';

const propTypes = {
  defaultPhone: PropTypes.string,
  onSentPin: PropTypes.func.isRequired,
  onEmailAuth: PropTypes.func.isRequired,
  allowEmailAuth: PropTypes.bool,
  phoneAuthProps: PropTypes.object,
};

const AuthModePhone = ({
  defaultPhone,
  onSentPin,
  onEmailAuth,
  allowEmailAuth,
  phoneAuthProps = {},
}) => {
  const requestConfirm = useRequestConfirm();

  const handleEmailAuthClick = () => {
    requestConfirm({
      title: (
        <>
          <WarningIcon color="#fe5851" size={24} className="mb-2" /> <br />{' '}
          Caution
        </>
      ),
      message: (
        <p className="text-center">
          If you created your account with your mobile number, you may lose
          access to some of the events you&apos;ve joined by signing in with
          email.
        </p>
      ),
      confirmText: 'Proceed with email login',
      cancelText: 'Login with my mobile',
      onConfirm: () => {
        onEmailAuth();
      },
      onCancel: () => {},
    });
  };

  return (
    <Fragment>
      <PhoneAuthContainer
        introText=""
        submitText="Send SMS"
        className="login-phone-input-form"
        pinSubmitText="Verify via SMS"
        onSentPin={onSentPin}
        defaultPhone={defaultPhone}
        onEmailAuth={onEmailAuth}
        {...phoneAuthProps}
        data-testid="phone-auth-container"
      />
      {allowEmailAuth && (
        <div className="text-center mt-4">
          <Button
            btnSize="sm"
            btnStyle="link"
            className="text-bold"
            onClick={handleEmailAuthClick}
            data-testid="email-toggle"
          >
            Did you create your account with an email?
          </Button>
        </div>
      )}
    </Fragment>
  );
};

AuthModePhone.propTypes = propTypes;

export default AuthModePhone;
